import { RigidHaulTruckBody } from './RigidHaulTruckBody';
import { RIGID_HAUL_TRUCK } from './dimensions';
import { RIGID_HAUL_TRUCK_LAYOUT, RIGID_HAUL_TRUCK_WHEELS } from './wheels';

const rigidHaulTruck6Preset = {
  id: 'rigid-haul-truck-6-standard',
  silhouette: 'rigid_haul_truck',
  renderModelKey: 'rigid_haul_truck',
  renderLayoutKey: 'rigid_haul_truck-6-wheel-v1',
  label: '2 axles, single steer and dual drive',
  layout: RIGID_HAUL_TRUCK_LAYOUT,
  wheels: RIGID_HAUL_TRUCK_WHEELS,
  camera: {
    position: [10.2, 5.4, 9.4],
    target: [0, 1.75, 0],
    minDistance: 7,
    maxDistance: 28,
    fov: 32,
  },
  stage: { extent: RIGID_HAUL_TRUCK.length, contactHeight: 1.65 },
  skeleton: 'axles',
  Body: RigidHaulTruckBody,
};

export { rigidHaulTruck6Preset };
